import { render } from "./icons-linkedin.svg?vue&type=template&id=644a15a1?inline"
const script = {}
script.render = render

export default script